function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========================================================================
 * Apricot's Horizontal Carousel
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";
import "../scss/includes/icon.scss";
import "../scss/includes/horizontal-carousel.scss";

// javaScript
import Utils from "./CBUtils";

/**
 * Horizontal Carousel
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @param {Boolean} data.markup
 * @param {String} data.itemClass
 * @param {Number} data.scrollDistance
 * @param {String} data.selectedClass
 * @returns {{scrollToLeft: Function}}
 * @returns {{scrollToRight: Function}}
 * @returns {{destroy: Function}}
 *
 */
var HorizontalCarousel = function HorizontalCarousel() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null,
    markup: true,
    scrollDistance: 150,
    itemClass: "cb-card",
    selectedClass: "cb-selected"
  };
  data = _objectSpread(_objectSpread({}, defaultData), data);
  var elem = data.elem;
  var nav = null;
  var navLeft = null;
  var navRight = null;
  var navContents = null;
  var scrollDistance = data.scrollDistance;
  var scrollCheck = false;
  var itemNodes = null;
  var settings = {
    transition: false,
    direction: ""
  };
  var init = function init() {
    elem.horizontalCarouselPlugin = "cb";
    if (!Utils.elemExists(elem)) return null;
    nav = elem.querySelector(".cb-horizontal-carousel-nav");
    navContents = elem.querySelector(".cb-horizontal-carousel-content");
    var selectedContent = navContents.querySelector("." + data.selectedClass);
    if (data.markup) {
      buildNavbar();
    } else {
      navLeft = elem.querySelector(".cb-horizontal-nav-left");
      navRight = elem.querySelector(".cb-horizontal-nav-right");
    }

    //  determine if overflow is in place
    Utils.attr(elem, "data-cb-overflow", overflowDirection());
    nav.addEventListener("scroll", addNavEvents);
    navRight.querySelector("a").addEventListener("click", addNavRightEvents);
    navLeft.querySelector("a").addEventListener("click", addNavLeftEvents);
    navContents.addEventListener("transitionend", addTransitionEvents, false);
    Utils.breakpoints();
    document.addEventListener("apricot_breakpointChange", function (e) {
      Utils.attr(elem, "data-cb-overflow", overflowDirection());
    });
    if (selectedContent && nav) {
      var navStart = nav.getBoundingClientRect().left;
      var navHalfWayPoint = navStart + nav.offsetWidth / 2;
      var selectedStart = selectedContent.getBoundingClientRect().left;
      var selectedHalfWayPoint = selectedStart + selectedContent.offsetWidth / 2;
      var scrollDestination = selectedHalfWayPoint - navHalfWayPoint;
      nav.scroll(scrollDestination, 0);
    }
    itemNodes = nav.querySelectorAll("." + data.itemClass);
    if (itemNodes.length > 0) {
      var _observer = new IntersectionObserver(onIntersection, {
        root: nav,
        rootMargin: "0px",
        threshold: 1
      });
      itemNodes.forEach(function (item, i) {
        _observer.observe(item);
        if (i === 0) {
          var parent = Utils.parent(item);
          if (parent && (parent.tagName.toLowerCase() === "ul" || parent.tagName.toLowerCase() === "ol")) {
            Utils.attr(parent, "role", "presentation");
          }
        }

        //GS-10290: move item into view on click
        item.addEventListener("click", function (event) {
          event.target.scrollIntoView({
            block: "nearest"
          });
        });

        // GS-10358
        Utils.attr(item, "role", "group");
        Utils.attr(item, "aria-label", "item ".concat(i + 1, " of ").concat(itemNodes.length));
      });
    }
  };
  var getFocusableNodes = function getFocusableNodes(elem) {
    return elem.querySelectorAll(Utils.FOCUSABLE_ELEMENTS_ALL);
  };

  // callback is called on intersection change
  var onIntersection = function onIntersection(entries) {
    entries.forEach(function (entry) {
      var focusableNodes = getFocusableNodes(entry.target);

      // add aria-hidden to cards
      if (entry.isIntersecting) {
        Utils.removeAttr(entry.target, "aria-hidden");

        // control tab behaviour of FocusableNodes
        focusableNodes.forEach(function (node) {
          Utils.attr(node, "tabindex", "0");
          Utils.removeAttr(node, "aria-hidden");
        });
      } else {
        Utils.attr(entry.target, "aria-hidden", "true");

        // control tab behaviour of FocusableNodes
        focusableNodes.forEach(function (node) {
          Utils.attr(node, "tabindex", "-1");
          Utils.attr(node, "aria-hidden", "true");
        });
      }
    });
  };
  var buildNavbar = function buildNavbar() {
    // ------- Right
    navRight = document.createElement("DIV");
    Utils.addClass(navRight, "cb-horizontal-nav");
    Utils.addClass(navRight, "cb-horizontal-nav-right");
    var link1 = document.createElement("A");
    Utils.attr(link1, "href", "#");
    Utils.attr(link1, "tabindex", "-1");
    Utils.attr(link1, "aria-disabled", "true");
    Utils.attr(link1, "aria-label", "scroll carousel to right");
    var span1 = document.createElement("SPAN");
    Utils.addClass(span1, ["cb-icon", "cb-right"]);
    Utils.attr(span1, "aria-hidden", "true");
    link1.appendChild(span1);
    navRight.appendChild(link1);

    // ------- Left
    navLeft = document.createElement("DIV");
    Utils.addClass(navLeft, "cb-horizontal-nav");
    Utils.addClass(navLeft, "cb-horizontal-nav-left");
    var link2 = document.createElement("A");
    Utils.attr(link2, "href", "#");
    Utils.attr(link2, "tabindex", "-1");
    Utils.attr(link2, "aria-disabled", "true");
    Utils.attr(link2, "aria-label", "scroll carousel to left");
    var span2 = document.createElement("SPAN");
    Utils.addClass(span2, ["cb-icon", "cb-left"]);
    Utils.attr(span2, "aria-hidden", "true");
    link2.appendChild(span2);
    navLeft.appendChild(link2);
    elem.insertBefore(navLeft, elem.querySelector(".cb-horizontal-carousel-nav"));
    elem.appendChild(navRight);
  };
  var overflowDirection = function overflowDirection() {
    var containerMetrics = nav.getBoundingClientRect();
    var containerMetricsRight = Math.floor(containerMetrics.right);
    var containerMetricsLeft = Math.floor(containerMetrics.left);
    var contentMetrics = navContents.getBoundingClientRect();
    var contentMetricsRight = Math.floor(contentMetrics.right);
    var contentMetricsLeft = Math.floor(contentMetrics.left);
    if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
      a11y(navRight, true);
      a11y(navLeft, true);
      return "both";
    } else if (contentMetricsLeft < containerMetricsLeft) {
      a11y(navRight, false);
      a11y(navLeft, true);
      return "left";
    } else if (contentMetricsRight > containerMetricsRight) {
      a11y(navRight, true);
      a11y(navLeft, false);
      return "right";
    } else {
      a11y(navRight, false);
      a11y(navLeft, false);
      return "none";
    }
  };
  var adjustScroll = function adjustScroll() {
    Utils.attr(elem, "data-cb-overflow", overflowDirection());
  };
  var addNavEvents = function addNavEvents(e) {
    // scrollPosition: last_known_scroll_position
    // ticking : scrollCheck
    // scrollPosition = window.scrollY
    if (!scrollCheck) {
      window.requestAnimationFrame(function () {
        adjustScroll();
        scrollCheck = false;
      });
    }
    scrollCheck = true;
  };
  var addNavLeftEvents = function addNavLeftEvents(e, scrollValue) {
    if (e) e.preventDefault();
    if (settings.transition === true) return;
    if (overflowDirection() === "left" || overflowDirection() === "both") {
      var availableScrollLeft = nav.scrollLeft;
      if (scrollValue) {
        navContents.style.transform = "translateX(".concat(scrollValue, "px)");
      } else {
        if (availableScrollLeft < scrollDistance * 2) {
          navContents.style.transform = "translateX(".concat(availableScrollLeft, "px)");
        } else {
          navContents.style.transform = "translateX(".concat(scrollDistance, "px)");
        }
      }
      Utils.removeClass(navContents, "cb-no-transition");

      // Update settings
      settings.direction = "left";
      settings.transition = true;
    }
    Utils.attr(elem, "data-cb-overflow", overflowDirection());
  };
  var addNavRightEvents = function addNavRightEvents(e, scrollValue) {
    if (e) e.preventDefault();
    if (settings.transition === true) return;
    if (overflowDirection() === "right" || overflowDirection() === "both") {
      var navBarRightEdge = navContents.getBoundingClientRect().right;
      var navBarScrollerRightEdge = nav.getBoundingClientRect().right;
      var availableScrollRight = Math.floor(navBarRightEdge - navBarScrollerRightEdge);
      if (scrollValue) {
        navContents.style.transform = "translateX(-".concat(scrollValue, "px)");
      } else {
        if (availableScrollRight < scrollDistance * 2) {
          navContents.style.transform = "translateX(-".concat(availableScrollRight, "px)");
        } else {
          navContents.style.transform = "translateX(-".concat(scrollDistance, "px)");
        }
      }
      Utils.removeClass(navContents, "cb-no-transition");

      // Update settings
      settings.direction = "right";
      settings.transition = true;
    }
    Utils.attr(elem, "data-cb-overflow", overflowDirection());
  };
  var addTransitionEvents = function addTransitionEvents(e) {
    // get the value of the transform, apply that to the current scroll position (so get the scroll pos first) and then remove the transform
    var styleOfTransform = window.getComputedStyle(navContents, null);
    var tr = styleOfTransform.getPropertyValue("-webkit-transform") || styleOfTransform.getPropertyValue("transform");
    // If there is no transition we want to default to 0 and not null
    var amount = Math.abs(parseInt(tr.split(",")[4]) || 0);
    navContents.style.transform = "none";
    Utils.addClass(navContents, "cb-no-transition");
    // Now lets set the scroll position
    if (settings.direction === "left") {
      nav.scrollLeft = nav.scrollLeft - amount;
    } else {
      nav.scrollLeft = nav.scrollLeft + amount;
    }

    // Update settings
    settings.transition = false;
  };

  // mode: 1, show
  // mode: 0, show
  var a11y = function a11y(nav, mode) {
    var a = nav.querySelector("a");
    if (mode) {
      Utils.attr(a, "tabindex", "0");
      Utils.attr(a, "aria-disabled", "false");
    } else {
      Utils.attr(a, "tabindex", "-1");
      Utils.attr(a, "aria-disabled", "true");
    }
  };
  var destroy = function destroy() {
    if (elem.horizontalCarouselPlugin === "cb") {
      elem.horizontalCarouselPlugin = null;
    }
    nav.removeEventListener("scroll", addNavEvents);
    navRight.querySelector("a").removeEventListener("click", addNavRightEvents);
    navLeft.querySelector("a").removeEventListener("click", addNavLeftEvents);
    navContents.removeEventListener("transitionend", addTransitionEvents, false);
    itemNodes && itemNodes.forEach(function (item) {
      observer.observe(item);
    });
  };
  if (elem.horizontalCarouselPlugin !== "cb") {
    init();
  }
  return {
    scrollToLeft: addNavLeftEvents,
    scrollToRight: addNavRightEvents,
    destroy: destroy
  };
};
export default HorizontalCarousel;